// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";

import exitFlow from "./slices/exitFlowSlice";
import toastReducer from "./slices/toastSlice";
import pinclueReducer, { replaceClueState } from "./slices/pinclueSlice";
import settingReducer, { replaceSettingsState } from "./slices/settingSlice";
import CreateUserReducer from "./slices/createUserSlice";
import { attachAxiosStore } from "../api/attachAxiosStore";

const store = configureStore({
  reducer: {
    exitFlow,
    toasts: toastReducer,
    pinclue: pinclueReducer,
    settings: settingReducer,
    createUser: CreateUserReducer,
  },
});

attachAxiosStore(store);

// Helper function to load state from localStorage into Redux
const initializeStoreFromLocalStorage = () => {
  try {
    // Load clue state
    const clueRaw = localStorage.getItem("clueState");
    if (clueRaw) {
      const clueData = JSON.parse(clueRaw);
      store.dispatch(replaceClueState(clueData));
    }

    // Load settings state
    const settingsRaw = localStorage.getItem("settings");
    if (settingsRaw) {
      const settingsData = JSON.parse(settingsRaw);
      store.dispatch(replaceSettingsState(settingsData));
    }
  } catch (error) {
    console.error("Failed to initialize store from localStorage:", error);
  }
};

if (typeof window !== "undefined") {
  // CRITICAL FIX: Wait for server snapshot restoration before loading into Redux
  // This event is dispatched by endHydration() in gamePersistence.js
  window.addEventListener("WTUFO_HYDRATED", () => {
    initializeStoreFromLocalStorage();
  });

  // FALLBACK: If syncOrchestrator doesn't start or takes too long (offline mode)
  // Initialize from localStorage after 2 seconds
  setTimeout(() => {
    const currentState = store.getState();

    // Check if clue state has already been initialized
    const clueInitialized = currentState.pinclue?.missions?.some((mission) => {
      return (
        mission.coins &&
        Object.values(mission.coins).some(
          (levelClues) =>
            Array.isArray(levelClues) && levelClues.some((clue) => clue.pinned)
        )
      );
    });

    // Check if settings has been initialized (compare with default values)
    const settingsInitialized =
      currentState.settings?.language !== undefined &&
      currentState.settings?.masterVolume !== undefined;

    if (clueInitialized && settingsInitialized) {
      return;
    }

    // No initialized data detected, load from localStorage
    initializeStoreFromLocalStorage();
  }, 2000);
}

export default store;
